import React from "react";
import {
  Keyboard,
  AddLocation,
  AllOut,
  School,
  LocationCity,
  Description,
  Clear,
  Search,
  SearchRounded,
} from "@material-ui/icons";
import {
  Box,
  Grid,
  Typography,
  Button,
  FormControlLabel,
  FormGroup,
  Checkbox,
  TextField,
  IconButton,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";

import { useDispatch, useSelector } from "react-redux";
import { collegeActions } from "../../_redux/collegeRedux";

import SelectFilter from "./selectFilter";
import TextFilter from "./textFilter";
import AppAutoComplete from "./AppAutoComplete";

// filter options
// import { getInstitutionTypes } from "./filterOptions/institutionType";
import { getStateList } from "./filterOptions/state";
import { getCollegeTypes } from "./filterOptions/collegeType";
import { getUniqeFieldOfStudy } from "./filterOptions/fieldOfStudy";
import { getDegreeTypes } from "./filterOptions/degreeType";
import { getRakingFilters } from "./filterOptions/rakingFilter";

const useStyles = makeStyles((theme) => ({
  searchTextFieldRoot: {
    "& .MuiFormLabel-root": {
      fontSize: "16px",
    },
    "& .MuiInputBase-root": {
      fontSize: "1.5rem",
    },
  },
  checkboxRoot: {
    "&.MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#3699FF",
    },
  },
  searchIconButton: {
    backgroundColor: "white",
    border: "1px solid black",
    color: "black",
  },
}));

export default () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { collegeListLoading, filters, initialFilter } = useSelector(
    (state) => ({
      filters: state.college.filters,
      initialFilter: state.college.initialFilter,
    })
  );

  const [localFilters, setLocalFilters] = React.useState(filters);

  const handleFiltersChange = (key, value) => {
    if (Array.isArray(localFilters[key])) {
      const matchIndex = localFilters[key].indexOf(value);
      if (matchIndex >= 0) {
        setLocalFilters({
          ...localFilters,
          [key]: localFilters[key].filter(
            (_, itemIndex) => itemIndex !== matchIndex
          ),
        });
      } else {
        setLocalFilters({
          ...localFilters,
          [key]: [...localFilters[key], value],
        });
      }
    } else {
      setLocalFilters({
        ...localFilters,
        [key]: value,
      });
    }
  };

  function applyFilters() {
    navigator.geolocation.getCurrentPosition(
      (data) => {
        dispatch(
          collegeActions.setFilters({
            ...localFilters,
            location: {
              latitude: data.coords.latitude,
              longitude: data.coords.longitude,
            },
          })
        );
      },
      (e) => {
        dispatch(
          collegeActions.setFilters({
            ...localFilters,
            location: null,
          })
        );
      }
    );
  }

  const clearFilter = () => {
    setLocalFilters(initialFilter);
    dispatch(
      collegeActions.setFilters({
        ...initialFilter,
        location: null,
      })
    );
  };

  const filterTypes = {
    dropdown: "dropdown",
    text: "text",
    checkbox: "checkbox",
  };

  const filterFields = [
    {
      keyName: "state",
      label: "State",
      type: filterTypes.dropdown,
      options: getStateList(),
      iconComponent: <AddLocation />,
    },
    {
      keyName: "zipCode",
      label: "Zip Code",
      type: filterTypes.text,
      iconComponent: <Keyboard />,
    },
    {
      keyName: "radius",
      label: "Radius",
      type: filterTypes.dropdown,
      iconComponent: <AllOut />,
      options: [5, 25, 100, 1000].map((v) => ({ key: `${v} miles`, value: v })),
    },
    {
      keyName: "collegeType",
      label: "College Type",
      type: filterTypes.dropdown,
      iconComponent: <LocationCity />,
      options: getCollegeTypes(),
    },
    {
      keyName: "degreeType",
      label: "Degree Type",
      type: filterTypes.dropdown,
      iconComponent: <School />,
      options: getDegreeTypes(),
    },
    {
      keyName: "ranking",
      label: "Ranking",
      type: filterTypes.dropdown,
      iconComponent: <School />,
      options: getRakingFilters(),
    },
  ];

  const checkBoxFilter = [
    {
      keyName: "campusSetting",
      label: "Campus Setting",
      options: ["City", "Suburb", "Town", "Rural"],
    },
    {
      keyName: "typeOfInstitution",
      label: "Type of Institution",
      options: ["Public", "Private"],
    },
  ];

  return (
    <>
      <Box justifyContent="center" mb={3}>
        <Grid
          container
          className="text-center"
          justify="center"
          alignItems="flex-end"
          spacing={2}
        >
          <Grid item sm="auto">
            <IconButton
              size="medium"
              className={classes.searchIconButton}
              onClick={applyFilters}
            >
              <SearchRounded />
            </IconButton>
          </Grid>
          <Grid item sm={11} md={5}>
            <TextField
              fullWidth={true}
              value={localFilters.search}
              onChange={(e) => handleFiltersChange("search", e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") applyFilters();
              }}
              id="standard-basic"
              label="Search colleges in your Area"
              classes={{ root: classes.searchTextFieldRoot }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        {/* Start Input filters */}
        <Grid container spacing={1} justify="center">
          {filterFields.map((f) => (
            <Grid item>
              {f.type === "dropdown" ? (
                <SelectFilter
                  label={f.label}
                  prefixIcon={f.iconComponent}
                  value={localFilters[f.keyName]}
                  setValue={(v) => handleFiltersChange(f.keyName, v)}
                  itemList={f.options}
                />
              ) : f.type === "text" ? (
                <TextFilter
                  placeholder={f.label}
                  prefixIcon={f.iconComponent}
                  value={localFilters[f.keyName]}
                  setValue={(v) => handleFiltersChange(f.keyName, v)}
                />
              ) : (
                ""
              )}
            </Grid>
          ))}
          <Grid item>
            <AppAutoComplete
              label="Field of Study"
              prefixIcon={<Description />}
              value={localFilters.fieldOfStudy}
              setValue={(v) => handleFiltersChange("fieldOfStudy", v)}
              itemList={getUniqeFieldOfStudy()}
            />
          </Grid>
        </Grid>
        {/* End Input Filter */}
        <Box my={3} />
        {/* Start Selection Filter */}
        <Grid container justify="center" alignItems="center" spacing={4}>
          <Grid item className="d-flex align-items-center">
            <Typography className="mr-5" variant="h6" color="initial">
              Campus Setting
            </Typography>
            <FormGroup row className="d-inline-block">
              {checkBoxFilter[0].options.map((item) => (
                <FormControlLabel
                  className="mb-0"
                  control={
                    <Checkbox
                      classes={{ root: classes.checkboxRoot }}
                      checked={localFilters[checkBoxFilter[0].keyName].includes(
                        item
                      )}
                      onChange={() =>
                        handleFiltersChange(checkBoxFilter[0].keyName, item)
                      }
                    />
                  }
                  label={item}
                />
              ))}
            </FormGroup>
          </Grid>
          <Grid item className="d-flex align-items-center">
            <Typography className="mr-5" variant="h6" color="initial">
              Type of institution
            </Typography>
            <FormGroup row className="d-inline-block">
              {checkBoxFilter[1].options.map((item) => (
                <FormControlLabel
                  className="mb-0"
                  control={
                    <Checkbox
                      classes={{ root: classes.checkboxRoot }}
                      checked={localFilters[checkBoxFilter[1].keyName].includes(
                        item
                      )}
                      onChange={() =>
                        handleFiltersChange(checkBoxFilter[1].keyName, item)
                      }
                    />
                  }
                  label={item}
                />
              ))}
            </FormGroup>
          </Grid>
        </Grid>
        {/* End Selection Filter */}
        <Box my={3} />
        {/* Start Action Buttons */}
        <Grid container justify="center" spacing={2}>
          <Grid item>
            <Button startIcon={<Clear />} onClick={() => clearFilter()}>
              Clear Filters
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              disabled={collegeListLoading}
              startIcon={!collegeListLoading ? <Search /> : ""}
              onClick={applyFilters}
              style={{ minWidth: "150px", color: "#ffffff" }}
            >
              {collegeListLoading ? (
                <CircularProgress style={{ color: "#3699FF" }} size={20} />
              ) : (
                "Apply Filters"
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
